import React from "react";

export const COLUMN_TYPE_CONFIG = {
  text: {
    color: { dark: "#A1A1AA", light: "#52525B" },
    icon: (
      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
        <path d="M4 7V4h16v3M9 20h6M12 4v16" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  },
  number: {
    color: { dark: "#60A5FA", light: "#3B82F6" },
    icon: (
      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
        <path d="M5 9h2m4 0h2m4 0h2M5 15h2m4 0h2m4 0h2M7 5v14m4-14v14m4-14v14" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  },
  price: {
    color: { dark: "#34D399", light: "#10B981" },
    icon: (
      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
        <path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  },
  link: {
    color: { dark: "#38BDF8", light: "#0369A1" },
    icon: (
      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
        <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  },
  image: {
    color: { dark: "#F472B6", light: "#EC4899" },
    icon: (
      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
        <rect x="3" y="3" width="18" height="18" rx="2" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
        <path d="M21 15l-5-5L5 21" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  },
  date: {
    color: { dark: "#FB923C", light: "#EA580C" },
    icon: (
      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
        <rect x="3" y="4" width="18" height="18" rx="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16 2v4M8 2v4M3 10h18" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  },
  email: {
    color: { dark: "#34D399", light: "#10B981" },
    icon: (
      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22 6l-10 7L2 6" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  },
  phone: {
    color: { dark: "#22D3EE", light: "#06B6D4" },
    icon: (
      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  },
  boolean: {
    color: { dark: "#4ADE80", light: "#22C55E" },
    icon: (
      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
        <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  },
  json: {
    color: { dark: "#FBBF24", light: "#D97706" },
    icon: (
      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
        <path d="M8 3H7a2 2 0 00-2 2v5a2 2 0 01-2 2 2 2 0 012 2v5c0 1.1.9 2 2 2h1M16 3h1a2 2 0 012 2v5c0 1.1.9 2 2 2a2 2 0 00-2 2v5a2 2 0 01-2 2h-1" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  },
  default: {
    color: { dark: "#A1A1AA", light: "#52525B" },
    icon: (
      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  }
};

/**
 * React component for column type icon with color
 * @param {string} type Column type
 * @param {boolean} isDarkMode Theme mode
 * @returns {JSX.Element} Colored icon component
 */
export const ColumnTypeIcon = ({ type, isDarkMode }) => {
  const config = COLUMN_TYPE_CONFIG[type] || COLUMN_TYPE_CONFIG.default;
  const color = isDarkMode ? config.color.dark : config.color.light;

  return (
    <span style={{ color }} className="flex items-center justify-center">
      {config.icon}
    </span>
  );
};

/**
 * Get the color for a column type
 * @param {string} type Column type
 * @param {boolean} isDarkMode Theme mode
 * @returns {string} Hex color string
 */
export const getColumnTypeColor = (type, isDarkMode) => {
  const config = COLUMN_TYPE_CONFIG[type] || COLUMN_TYPE_CONFIG.default;
  return isDarkMode ? config.color.dark : config.color.light;
};

/**
 * @deprecated Use ColumnTypeIcon component instead
 * Get SVG icon for column type (without theme support)
 */
export const getColumnTypeIcon = (type) => {
  const config = COLUMN_TYPE_CONFIG[type] || COLUMN_TYPE_CONFIG.default;
  return (
    <span style={{ color: config.color.light }} className="flex items-center justify-center">
      {config.icon}
    </span>
  );
};

/**
 * @deprecated Use ColumnTypeIcon component instead
 * Get emoji icon for column type
 * @param {string} type Column type
 * @returns {string} Emoji icon
 */
export const getColumnTypeEmoji = (type) => {
  switch (type) {
    case "text":
      return "📝";
    case "link":
      return "🔗";
    case "image":
      return "🖼️";
    case "number":
      return "🔢";
    case "date":
      return "📅";
    case "email":
      return "📧";
    case "phone":
      return "📱";
    case "boolean":
      return "✅";
    case "json":
      return "{ }";
    default:
      return "📄";
  }
};
